<div class="searchForm flex-row" #myForm id="formMinAnnonce">
    <div class="flex-row">
      <div class="form-row">
        <div class="col-md-6 col-6">
          <label class="sr-only" for="text" >Rechercher</label>
          <input type="text" [(ngModel)]="searchText" (input)="onFormChange()" class="form-control mb-2" id="text" placeholder="Rehercher ">
        </div>
        <div class="col-md-3 col-6">
            <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
            dropdownPosition='bottom' placeholder="Type De Place"
             [items]="placeTypes" [multiple]="true"
              [bindLabel]="'name'" (change)="onFormChange()"
             [closeOnSelect]="false" bindValue="name" [(ngModel)]="selectedPlaceTypes"
             name="selectRegion">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" (change)="onFormChange()" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
            </ng-template>
           </ng-select>
        </div>
      </div>
      <div class="d-flex">
        <div class="col-12 my-1">
          <button id="create-variable" class="btn btn-indigo float-right" type="submit" (click)="creer()">
            <span>
              Ajouter une Configuration
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
